import { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import WeekPicker from "../../user/phases/weekPicker";
import { UserApi } from "../../../apis";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const WeeklyTimeReport = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [timesheetData, setTimesheetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const open = Boolean(anchorEl);
  const [searchParams, setSearchParams] = useSearchParams();


  const fetchTimesheet = async (date) => {
    setLoading(true);
    try {

      const formattedDate = date ? dayjs(date).startOf("week").format("DD-MM-YYYY") : selectedDate.startOf("week").format("DD-MM-YYYY");
      console.log(formattedDate, "formattedDate");

      const response = await UserApi.getAllUserTimeSheetByPayload(formattedDate);

      if (response && response.data) {
        setTimesheetData(response.data);
      } else {
        setTimesheetData([]);
        setError("Invalid data format received from server");
      }
    } catch (err) {
      setError("Failed to fetch timesheet data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dateFromParams = searchParams.get("date");
    if (dateFromParams) {
      const parsedDate = dayjs(dateFromParams, "DD-MM-YYYY"); // Parse the string
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate); // Pass the dayjs object
      }
    }

  }, []);
  useEffect(() => {
    const dateFromParams = searchParams.get("date");
    if (dateFromParams) {
      const parsedDate = dayjs(dateFromParams, "DD-MM-YYYY"); // Parse the string
      if (parsedDate.isValid()) {
        fetchTimesheet(parsedDate); // Pass the dayjs object
      } else {
        console.error("Invalid date parameter:", dateFromParams);
        // Optionally handle the invalid date, e.g., reset to current week
        setSearchParams({ date: selectedDate.format("DD-MM-YYYY") });
        fetchTimesheet();
      }
    } else {
      setSearchParams({ date: selectedDate.format("DD-MM-YYYY") });
      fetchTimesheet();
    }
  }, [selectedDate]);

  const handleMenuClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user); // Store the correct user
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };
  const handleAction = async (action) => {
    if (!selectedUser) return;

    console.log(selectedUser, "userdata");
    const timeSheetId = selectedUser.timeSheetId;
    console.log(timeSheetId, "timesheetid");
    const userId = selectedUser.id;
    console.log(userId, "userID");

    if (action === "view") {
      navigate(`/admin/weekly-time-sheet/${userId}?date=${selectedDate.format("DD-MM-YYYY")}`);
    } else if (action === "approved" || action === "rejected") {
      await UserApi.approveTimeSheet(timeSheetId, action);
      fetchTimesheet();
    }
    handleMenuClose();
  };


  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">Weekly Timesheet</Typography>
        <Box sx={{ position: "relative" }}>
          <WeekPicker selectedDate={selectedDate} onDateChange={(cal) => {
            setSelectedDate(cal);
            setSearchParams({ date: cal.format("DD-MM-YYYY") });
            fetchTimesheet(cal);
          }} />
        </Box>
      </Box>

      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", height: 200 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead sx={{ backgroundColor: "#a4b0be" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Username</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Total Hours</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Projects</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Phases</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Hours</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {timesheetData.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell sx={{ fontWeight: "bold" }}>{user.user}</TableCell>
                    <TableCell>{user?.totalHours?.toFixed(2)}</TableCell>
                    <TableCell>
                      {user.rows &&
                        user.rows.map((row, index) => (
                          <Box
                            component="ul"
                            key={`${user.id}-project-${index}`}
                            sx={{ padding: 0, margin: 0 }}
                          >
                            {row.projects &&
                              row.projects.map((project, projectIndex) => (
                                <Box
                                  component="li"
                                  key={`${user.id}-project-${index}-${projectIndex}`}
                                  sx={{
                                    whiteSpace: "pre-line",
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                    fontSize: "14px",
                                  }}
                                >
                                  {project}
                                </Box>
                              ))}
                          </Box>
                        ))}
                    </TableCell>
                    <TableCell>
                      {user.rows &&
                        user.rows.map((row, index) => (
                          <Box
                            component="ul"
                            key={`${user.id}-phase-${index}`}
                            sx={{ padding: 0, margin: 0 }}
                          >
                            {row.phases &&
                              row.phases.map((phase, phaseIndex) => (
                                <Box
                                  component="li"
                                  key={`${user.id}-phase-${index}-${phaseIndex}`}
                                  sx={{
                                    whiteSpace: "pre-line",
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                    fontSize: "14px",
                                  }}
                                >
                                  {phase}
                                </Box>
                              ))}
                          </Box>
                        ))}
                    </TableCell>
                    <TableCell>
                      {user.rows &&
                        user.rows.map((row, index) => (
                          <div key={`${user.id}-hours-${index}`} style={{ marginBottom: "8px" }}>
                            {row.hours && row.totalForRow}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          backgroundColor:
                            user.status === "approved"
                              ? "green"
                              : user.status === "pending"
                                ? "yellow"
                                : "red",
                          color: user.status === "pending" ? "black" : "white",
                          padding: "4px 8px",
                          borderRadius: "50px",
                          display: "inline-block",
                          textAlign: "center",
                        }}
                      >
                        {user.status}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, user)}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                        <MenuItem onClick={() => handleAction("view")}>View Details</MenuItem>
                        <MenuItem onClick={() => handleAction("approved")}>Approve</MenuItem>
                        <MenuItem onClick={() => handleAction("rejected")}>Reject</MenuItem>

                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
                {timesheetData.length === 0 && !loading && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No timesheet data available for this week
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default WeeklyTimeReport;